import { conversationKeys } from '@/features/conversations';

/**
 * The chat settings live under the store's conversation keys. Shortcuts and departments share the inbox's cache entries (the composer's `/` palette and the
 * transfer menu read the same lists), so a change here shows there without a refetch.
 */
export const chatSettingsKeys = {
  settings: (storeId: string) => [...conversationKeys.store(storeId), 'chat-settings'] as const,
  shortcuts: (storeId: string) => conversationKeys.shortcuts(storeId),
  departments: (storeId: string) => conversationKeys.departments(storeId),
  bans: (storeId: string) => [...conversationKeys.store(storeId), 'bans'] as const,
  triggers: (storeId: string) => [...conversationKeys.store(storeId), 'triggers'] as const,
  discounts: (storeId: string) => conversationKeys.discounts(storeId),
  profile: (storeId: string) => [...conversationKeys.store(storeId), 'chat-profile'] as const,
};
